import createReactComponent from '../createReactComponent';
export default createReactComponent('multiplier-1-5x', 'IconMultiplier15x', [
  ['path', { d: 'M4 16v-8l-2 2', key: 'svg-0' }],
  ['path', { d: 'M10 16h2a2 2 0 1 0 0 -4h-2v-4h4', key: 'svg-1' }],
  ['path', { d: 'M7 16v.01', key: 'svg-2' }],
  ['path', { d: 'M17 16l4 -4', key: 'svg-3' }],
  ['path', { d: 'M21 16l-4 -4', key: 'svg-4' }],
]);
